import React from "react";

// Import Styles
import "../styles/Contact.css";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import Maps from "./Maps";

function Contact() {
  return (
    <div className="Contact">
      <div className="About__Main-Container">
        <div className="Left-Container contact-left">
          <h1>Visítanos</h1>
          <h2>Vive la experiencia de un barbero profesional</h2>
          <section className="contact-section-info">
            <div className="contact-item">
              <LocationOnIcon />
              <p>Calle Chiquitoy 102 - Urb. Arboleda Maranga - San Miguel</p>
            </div>
            <div className="contact-item">
              <QueryBuilderIcon />
              <p>Lunes a Domingo de 11:00 am a 10:00 pm</p>
            </div>
            <div className="contact-item">
              <WhatsAppIcon />
              <p>+51 931 580 247</p>
            </div>
            <div className="contact-item">
              <MailOutlineIcon />
              <p>joelquijandria.2309@gmail.com</p>
            </div>
          </section>
        </div>

        <div className="Right-Container Contact-Right">
          <Maps />
        </div>
      </div>
    </div>
  );
}

export default Contact;
